import Summary from './Summary'

export default Summary



// WEBPACK FOOTER //
// ./src/components/Orders/Summary/index.js